import { take, cancel, select, actionChannel } from "redux-saga/effects"

import {
  process as selectProcess,
  involved as selectInvolved,
} from "../selectors"
import { types } from "../actions"

export default function* releaseSaga() {
  const releaseRequest = yield actionChannel([types.release])
  while (true) {
    const action = yield take(releaseRequest)

    const { id, model, force } = action

    if (action.type === types.release) {
      const involved = yield select(selectInvolved, model, id)

      if (!involved || force) {
        const process = yield select(selectProcess, model, id)

        if (process) {
          // Cancel current process whatevet it is
          yield cancel(process.task)
        }
      }
    }
  }
}
